import Papa from 'papaparse'
import ShortUniqueId from 'short-unique-id'
import appsync from '@/api/appsync'
import router from '@/router'
import storage from '@/api/storage'
import { CsvProcessor } from '@/utils'
import PhoneNumber from "awesome-phonenumber"

// const defaultSecret = '**********'

const uid = new ShortUniqueId()

const state = {
  // listingId: null,
  // listingName: null,
  property: null,
  listing: null,
  guideUrl: null,
  reservation: null,
  lockDeviceId: null,
  keypadDeviceId: null,
  properties: [],
  reservations: [],
  reservationsTimestamp: new Date('2001-01-01'),
  members: [],
  notifications: [],
  reservationRooms: null,
  faceImgKeyCount: 0,
  host: null,
  devices: [],
  locks: [],
  keypads: [],
  pmsList: [],
  hostPms: null,
  returnUrl: null,
  expiresAt: null,
  spaces: [],
  assets: [],
  placedAssets: [],
  removedSpaces: []
}

const actions = {
  async loadAssets({ commit, state }) {
    let rtn = await appsync.getAssets(state.property.hostPropertyCode, ['LOCK', 'KEYPAD', 'KEYPAD_LOCK', 'LOCK_BUTTON', 'CAMERA'])

    console.log('assets', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const assets = rtn.data.getAssets || [];
      commit('setAssets', assets)
    }

    console.log('state.property.hostPropertyCode', state.property.hostPropertyCode)

    rtn = await appsync.getPlacedAssets(state.property.hostPropertyCode, 0, ['LOCK', 'KEYPAD', 'KEYPAD_LOCK', 'LOCK_BUTTON', 'CAMERA'])

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      console.log('rtn.data.getPlacedAssets', rtn.data.getPlacedAssets)

      // Get placed assets from API response, defaulting to empty array if undefined
      const placedAssets = rtn.data.getPlacedAssets || [];
      commit('setPlacedAssets', placedAssets)
    }
  },
  async loadSpaces({ commit, state }, hostPropertyCode) {
    console.log('loadSpaces hostPropertyCode', hostPropertyCode)

    const rtn = await appsync.getSpaces(hostPropertyCode, 0)
    console.log('loadSpaces spaces', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const spaces = rtn.data.getSpaces
      commit('setSpaces', spaces)
      commit('setRemovedSpaces', []) // Reset removedSpaces when loading new spaces
    }
  },
  async loadProperties({ commit, rootState }) {
    // console.log('rootState.session', rootState.session)

    const rtn = await appsync.getProperties(rootState.session.hostId)
    console.log('properties', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const properties = rtn.data.getProperties

      commit('setProperties', properties)
    }
  },
  async loadCalendarReservations({ commit, rootState, dispatch }, val) {
    // await dispatch('loadListings')
    // console.log('state.listings', state.listings)
    // await dispatch('loadReservations', state.listings)

    const rtn = await appsync.listReservations(rootState.session.hostId, val.startDate, val.endDate, val.listingId)

    const reservations = rtn.data.listReservations

    commit('setReservations', reservations)

  },
  // async loadListingLocks({ commit, state, rootState }) {
  //   console.log('loadListingLocks')

  //   const rtn = await appsync.getPropertyLocks(`${state.listing.hostId}-${state.listing.propertyCode}`)

  //   if (rtn.errors) {
  //     throw rtn.errors[0]
  //   } else {
  //     const keypads = rtn.data.getPropertyLocks.filter(device => {
  //       return device.withKeypad
  //     }).map(device => {
  //       delete device.withKeypad
  //       delete device.propertyCode
  //       return device
  //     })

  //     const locks = rtn.data.getPropertyLocks.filter(device => {
  //       return !(device.withKeypad)
  //     })

  //     console.log('locks', locks)

  //     console.log('keypads', keypads)

  //     commit('setLocks', locks)

  //     commit('setKeypads', keypads)
  //   }
  // },
  async loadListings({ commit, rootState }) {
    // console.log('rootState.session', rootState.session)

    const rtn = await appsync.getListings(rootState.session.hostId)
    console.log('listings', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const listings = rtn.data.getListings

      commit('setListings', listings)
    }
  },
  async createListing({ commit, state, rootState }, val) {
    val.hostId = rootState.session.hostId
    val.listingId = uid.randomUUID(6)
    val.propertyCode = val.internalName.split(' ')[0]

    if (!val.pmsUserId || !val.pmsListingId) {
      delete val.pmsUserId
      delete val.pmsListingId
    }

    const rtn = await appsync.createListing(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const listing = rtn.data.createListing

      await appsync.refreshProperty(listing.hostId, listing.propertyCode)

      state.listings.push(listing)
    }
  },
  async updateListing({ commit, state }, val) {
    // console.log('updateListing before', val.params)
    delete val.params.address
    delete val.params.picture

    const rtn = await appsync.updateListing(val.params)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      // console.log('updateListing after', rtn.data.updateListing)
      const listing = rtn.data.updateListing

      // console.log('updateListing listings before', state.listings)
      Object.assign(state.listings[val.index], listing)
      // console.log('updateListing listings after', state.listings)
    }
  },
  async importReservations({ dispatch, state }, val) {
    if (!state.hostPms) {
      await dispatch('getHostPms')
    }

    const rtn = await appsync.importReservations({ hostId: val.hostId, listingId: val.listingId }, state.hostPms.pmsType)

    console.log('importReservations rtn', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {

    }
  },
  async importListings({ commit, dispatch, state }) {

    if (!state.hostPms) {
      await dispatch('getHostPms')
    }

    const rtn = await appsync.importListings(state.hostPms)

    console.log('importListings rtn', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      // state.listings = rtn.data.importListings
      await dispatch('loadListings')
    }
  },
  async loadMembers({ commit, state }) {

    const rtn = await appsync.getMembers(state.reservation.reservationCode)
    console.log('loadMembers rtn', rtn)
    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const members = rtn.data.getMembers

      if (members.length <= state.reservation.memberCount) {
        const existingMemberNos = members.map((item) => {
          return item.memberNo
        })

        let i = 1

        for (i; i <= state.reservation.memberCount; i++) {
          if (existingMemberNos.indexOf(i) === -1) {
            members.push({
              reservationCode: state.reservation.reservationCode,
              memberNo: i,
              idImgKey: null,
              faceImgKey: null,
              checkInImgKey: null,
              keyNotified: false,
              keyInfo: state.reservation.keyInfo,
            })
          }
        }
      } else {
        members.forEach(member => {
          if (!member.keyInfo) {
            member.keyInfo = state.reservation.keyInfo
          }
        })
      }

      members.sort((a, b) => {
        if (a.memberNo < b.memberNo)
          return -1
        if (a.memberNo > b.memberNo)
          return 1
        return 0
      })

      commit('setMembers', members)
    }

  },
  async updateMember({ commit, state }, val) {
    delete val.checkInImgKey
    delete val.keyNotified

    const rtn = await appsync.updateMember(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      console.log('rtn.data.updateMember', rtn.data.updateMember)

      const member = rtn.data.updateMember

      const index = member.memberNo - 1
      Object.assign(state.members[index], member)

    }
  },
  async validateCalendar({ commit, state }, val) {
    console.log('validateCalendar', val)
    console.log('validateCalendar listing.spaces', state.listing.spaces)

    const calendarPromises = state.listing.spaces.map(space => {
      const params = { ...val.params, resourceId: space.assetId }
      return appsync.getCalendars(params)
    })

    const results = await Promise.allSettled(calendarPromises)

    const successfulResults = []
    const errors = []

    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        const rtn = result.value
        if (rtn.errors) {
          errors.push({
            assetId: state.listing.spaces[index].assetId,
            error: rtn.errors[0]
          })
        } else {
          successfulResults.push({
            assetId: state.listing.spaces[index].assetId,
            calendars: rtn.data.getCalendars
          })
        }
      } else {
        errors.push({
          assetId: state.listing.spaces[index].assetId,
          error: result.reason
        })
      }
    })

    if (errors.length > 0 && successfulResults.length === 0) {
      throw errors[0].error
    }

    return {
      successful: successfulResults,
      errors: errors
    }
  },
  async onUpdateReservation({ state, rootState }) {
    // console.log('host.js onUpdateReservation rootState.session.hostId', rootState.session.hostId)
    console.log('host.js onUpdateReservation state.listing', state.listing)

    if (state.listing) {
      return appsync.onUpdateReservation(rootState.session.hostId, state.listing.listingId)
    } else {
      return appsync.onUpdateReservation(rootState.session.hostId)
    }


  },
  async onRemoveReservation({ state, rootState }) {
    return appsync.onRemoveReservation(rootState.session.hostId)
  },
  async updateReservation({ commit, state, rootState }, val) {
    console.log('host.updateReservation', val)

    val.phoneNo = PhoneNumber(val.phoneNo).getNumber('e164')

    const rtn = await appsync.generateReservation(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    }
  },
  async generateReservation({ commit, state, rootState }, val) {
    console.log('host.generateReservation', val)

    val.hostId = rootState.session.hostId
    val.listingId = state.listing.listingId
    // val.listingName = state.listingName
    // delete val.reservationCode

    // Normalize Phone Number, Added on 20190513
    const normalizedNo = PhoneNumber(val.phoneNo).getNumber('e164')
    val.phoneNo = normalizedNo
    // Normalize Phone Number, Added on 20190513

    const rtn = await appsync.generateReservation(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      // const reservation = rtn.data.generateReservation

      // state.reservations.push(reservation)
    }
  },
  async updateReservationStatus({ commit, state }, params) {
    console.log('store.host.updateReservationStatus in: params:', params)

    const rtn = await appsync.updateReservationStatus(params)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
    }
  },
  async updateIdVerified({ commit, state }, val) {
    console.log('store.host.updateIdVerified in: val:', val)

    const rtn = await appsync.updateIdVerified(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
    }
  },
  async notifyGuest({ commit, state }, val) {
    console.log('store.host.notifyGuest in: val:', val)

    const rtn = await appsync.notifyGuest(val.reservation, val.messageType)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
    }
  },
  async removeReservation({ commit, state }, val) {
    console.log('store.host.removeReservation in: val:', val)

    const rtn = await appsync.removeReservation(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    }
  },
  async loadReservations({ commit, state }, listings) {

    const responses = await Promise.all(listings.map(async (listing) => {
      const response = await appsync.getReservations(listing.listingId)
      const rtn = response.data.getReservations
      rtn.forEach(reservationItem => {
        reservationItem.internalName = listing.internalName
      })
      return rtn
    }))

    const reservationItems = responses.flat()
    console.log('reservationItems', reservationItems)

    commit('setReservations', reservationItems)
  },
  // TODO need to check listingId for filter
  postRemoveReservations({ state, commit }, val) {

    console.log('postRemoveReservations', val)

    const newReservations = state.reservations.filter(reservation => reservation.reservationCode != val.reservationCode)

    commit('setReservations', newReservations)

  },
  // TODO need to check listingId for findIndex
  refreshReservations({ state, commit }, val) {

    console.log('refreshReservations', val)

    const newReservations = Object.assign(state.reservations)

    const index = newReservations.findIndex((crt, crtIndex) => crt.reservationCode == val.reservationCode)

    if (index > -1) {
      Object.assign(newReservations[index], val)
    } else {
      newReservations.push(val)
    }

    commit('setReservations', newReservations)

  },
  gotoLayout({ commit }) {
    console.log('gotoLayout')

    router.push({ path: '/layout' })
  },
  gotoListings({ commit }, val) {
    console.log('gotoListings', val)

    router.push({ path: '/' })
  },
  gotoReservations({ commit }, val) {
    console.log('gotoReservations', val)

    // commit('setListingId', val.listingId)
    // commit('setListingName', val.listingName)
    // commit('setGuideUrl', val.guideUrl)

    commit('setListing', val)

    router.push({ path: '/reservations' })
  },
  gotoMembers({ commit, state }, val) {
    console.log('gotoMembers', val)

    const crtListing = state.listings.find(listing => listing.listingId == val.listingId)

    commit('setListing', crtListing)

    commit('setReservation', val)

    if (router.currentRoute.name === 'members') {
      router.go()
    } else {
      router.push({ path: '/members' })
    }

  },
  pickProperty({ commit }, val) {
    console.log('pickProperty', val)

    commit('setProperty', val)

  },
  pickListing({ commit }, val) {
    console.log('pickListing', val)

    commit('setListing', val)

  },
  pickReservation({ commit }, val) {
    console.log('pickReservation', val)

    commit('setReservation', val)

  },
  async uploadJson({ rootState, state, dispatch }, { fileObject }) {
    // console.log('uploadJson', fileObject)

    const result = await dispatch('parseFile', fileObject).catch(e => {
      console.error('parseFile', e)
      throw e
    })

    // console.log('parseFile result', result)

    const reservations = result.map(item => {

      item.listingId = state.listing.listingId
      item.hostId = rootState.session.hostId

      return item
    })

    console.log('parseFile reservations', reservations)

    // await storage.putJson(uid.randomUUID(8) + '.json', reservations)

    await storage.putJson(`reservations/json/${rootState.session.hostId}/${state.listing.listingId}/${uid.randomUUID(8)}.json`, reservations)
  },
  async uploadCsv({ rootState, state, dispatch }, csvFile) {
    console.log('uploadCsv', csvFile.file)

    await storage.putCsv(`reservations/csv/${rootState.session.hostId}/${state.listing.listingId}/${uid.randomUUID(8)}.csv`, csvFile.file)
  },
  readFile({ commit }, fileObject) {
    return new Promise((resolve, reject) => {

      const reader = new FileReader()
      reader.onload = (event) => {
        resolve(event.target.result)
      }

      reader.readAsArrayBuffer(fileObject)
    })
  },
  parseFile({ commit }, fileObject) {
    return new Promise((resolve, reject) => {

      Papa.parse(fileObject, {
        header: true,
        skipEmptyLines: true,
        beforeFirstChunk: chunk => {
          const rows = chunk.split(/\r\n|\r|\n/)
          console.log('parseFile', rows)
          const headings = rows[0].split(',').map(header => header.replaceAll('"', ''))

          const newHeadings = CsvProcessor.transformHeaderAirbnb(headings)
          rows[0] = newHeadings.join()

          return rows.join('\n')
        },
        transform: (value, columnNo) => {
          try {
            return CsvProcessor.transformAirbnb(value, columnNo)
          }
          catch (error) {
            reject('transformAirbnb', error)
          }

          // return CsvProcessor.transformAirbnb(value, columnNo)

        },
        complete: results => {
          //todo getrid of erro by results.error
          console.log('parseFile complete results', results)
          resolve(results.data)
        }
      })

    })
  },
  // async onCreateNotification ({ rootState }) {
  //   return appsync.onCreateNotification(rootState.session.hostId)
  // },
  // async loadNotifications ({ commit, rootState }) {
  //   // console.log('loadNotifications rootState.session.hostId', rootState.session.hostId)

  //   const rtn = await appsync.getNotifications(rootState.session.hostId)
  //   console.log('getNotifications', rtn)

  //   if (rtn.errors) {
  //     throw rtn.errors[0]
  //   } else {

  //     const notifications = rtn.data.getNotifications

  //     commit('setNotifications', notifications)
  //   }
  // },
  // addNotification ({ state }, onCreateNotificationData) {
  //   state.notifications.push(onCreateNotificationData)

  //   console.log('state.notifications.length', state.notifications.length)
  // },
  // async removeNotification ({ state }, notification) {

  //   const params = {
  //     hostId: notification.hostId,
  //     reservationCode: notification.reservationCode
  //   }

  //   const rtn = await appsync.deleteNotification(params)

  //   if (rtn.errors) {
  //     throw rtn.errors[0]
  //   } else {
  //     const data = rtn.data.deleteNotification

  //     const index = state.notifications.indexOf(notification)
  //     if (index > -1) {
  //       state.notifications.splice(index, 1)
  //     }
  //   }
  // },
  async onUpdateDevice({ state }) {
    return appsync.onUpdateDevice(state.host.listing.listingId)
  },
  async putLayoutImage({ commit, state, rootState }, { imgFile, layoutId }) {

    console.log('state.property.', state.property)

    const imgKey = `${rootState.session.hostId}/properties/${state.property.propertyCode}/layouts/${layoutId}.jpg`
    const imgKeyFull = `private/${rootState.session.identityId}/${rootState.session.hostId}/properties/${state.property.propertyCode}/layouts/${layoutId}.jpg`

    await storage.putImage(imgKey, imgFile, imgFile.type)

    console.log('imgKey', imgKey)

    return imgKey

  },
  async putMemberImage({ commit, state, rootState }, { member, imgFile, isId }) {

    if (isId) {
      const imgKey = `${rootState.session.hostId}/listings/${state.reservation.listingId}/${member.reservationCode}/id/${member.memberNo}.jpg`
      member.idImgKey = `private/${rootState.session.identityId}/${rootState.session.hostId}/listings/${state.reservation.listingId}/${member.reservationCode}/id/${member.memberNo}.jpg`

      await storage.putImage(imgKey, imgFile.file, imgFile.type)

      const index = member.memberNo - 1
      Object.assign(state.members[index], member)
    } else {
      const imgKey = `${rootState.session.hostId}/listings/${state.reservation.listingId}/${member.reservationCode}/face/${member.memberNo}.jpg`
      member.faceImgKey = `private/${rootState.session.identityId}/${rootState.session.hostId}/listings/${state.reservation.listingId}/${member.reservationCode}/face/${member.memberNo}.jpg`

      await storage.putImage(imgKey, imgFile.file, imgFile.type)
      const index = member.memberNo - 1
      Object.assign(state.members[index], member)
    }

  },
  async validateFaceImgs({ commit, state, rootState }) {

    const rtn = await appsync.getMembers(state.reservation.reservationCode)

    console.log('getMembers rtn', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const members = rtn.data.getMembers

      // const roomSet = new Set()
      let faceImgKeyCount = 0

      members.forEach(member => {
        if (member.faceImgKey) {
          faceImgKeyCount++
        }
      })

      if (faceImgKeyCount < state.reservation.memberCount || faceImgKeyCount == 0) {
        throw new Error('Face image of each member is required!')
      }
    }

  },
  async updateHost({ commit, state }, val) {
    console.log('updateHost', val)

    // if (val.smartlockProperty.clientId == defaultSecret || val.smartlockProperty.clientSecret == defaultSecret) {
    //   delete val.smartlockProperty.clientId
    //   delete val.smartlockProperty.clientSecret
    // }

    const rtn = await appsync.updateHost(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    }

    commit('setHost', rtn.data.updateHost)
  },
  async loadHost({ commit, rootState }) {

    const rtn = await appsync.getHost(rootState.session.hostId)
    console.log('loadHost', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      const host = rtn.data.getHost

      if (!host.smartlockProperty) {
        host.smartlockProperty = {}
      }
      commit('setHost', host)
    }
  },
  async refreshDevices({ commit, rootState }, val) {
    console.log('refreshDevices', val)

    const rtn = await appsync.refreshDevices(val)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      console.log('refreshDevices', rtn.data.refreshDevices)
    }
  },
  async verifyChannel({ commit, state }, { inviteCode, hostId }) {
    console.log('verifyChannel', { inviteCode, hostId })

    const rtn = await appsync.verifyChannel(inviteCode, hostId)

    console.log('verifyChannel rtn', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    }

    commit('setHost', rtn.data.verifyChannel)
  },
  async updateHostPms({ commit, rootState }, val) {
    console.log('updateHostPms', val)

    let rtn
    if (val[0].pmsType) {
      rtn = await appsync.updateHostPms(rootState.session.hostId, val)
    } else {
      rtn = await appsync.updateHostPms(rootState.session.hostId)
    }

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      if (rtn.data.updateHostPms?.length > 0) {
        commit('setHostPms', rtn.data.updateHostPms[0])
      }
    }

  },
  async initHostPms({ commit, rootState }, pmsType) {
    console.log('initHostPms', pmsType)

    const rtn = await appsync.initHostPms({
      hostId: rootState.session.hostId,
      pmsType: pmsType
    })

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      console.log('initHostPms', rtn.data.initHostPms)

      commit('setReturnUrl', rtn.data.initHostPms.returnUrl)

      commit('setExpiresAt', rtn.data.initHostPms.expiresAt)
    }
  },
  async getPmsList({ commit, rootState }) {
    console.log('getPmsList')

    const rtn = await appsync.getPmsList()

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      console.log('getPmsList', rtn)
      commit('setPmsList', rtn.data.getPmsList)
    }
  },
  async getHostPms({ commit, rootState }) {
    console.log('getHostPms hostId', rootState.session.hostId)

    const rtn = await appsync.getHostPms(rootState.session.hostId)

    if (rtn.errors) {
      throw rtn.errors[0]
    } else {
      console.log('getHostPms', rtn)
      if (rtn.data.getHostPms.length > 0) {
        commit('setHostPms', rtn.data.getHostPms[0])
      } else {
        commit('setHostPms', null)
      }
    }
  },
  async saveLayout({ state, rootState }, val) {
    console.log('saveLayout', JSON.stringify(val))

    let rtn = await appsync.refreshProperty(rootState.session.hostId, state.property.propertyCode, state.property.coreName, [val.imgKey])

    console.log('refreshProperty rtn', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    }

    // Ensure removedSpaces is an array
    const removedSpaces = (val.removedSpaces || []).map(space => {
      return {
        hostId: rootState.session.hostId,
        uuid: space.uuid,
        coreName: state.property.coreName
      }
    })

    // Ensure spaces is an array before filtering
    const newSpaces = (val.spaces || []).filter(space => !space.lastUpdateOn).map(space => {
      return {
        hostId: rootState.session.hostId,
        uuid: space.uuid,
        propertyCode: state.property.propertyCode,
        hostPropertyCode: state.property.hostPropertyCode,
        category: 'SPACE',
        coreName: state.property.coreName,
        assetId: space.uuid,
        assetName: space.assetName,
        layoutId: val.layoutId,
        center: space.center,
        path: space.path,
        allowOverlap: space.allowOverlap || false
      }
    })

    // Ensure spaces is an array before filtering
    const updatedSpaces = (val.spaces || []).filter(space => space.lastUpdateOn).map(space => {
      return {
        hostId: rootState.session.hostId,
        uuid: space.uuid,
        propertyCode: state.property.propertyCode,
        hostPropertyCode: state.property.hostPropertyCode,
        category: 'SPACE',
        coreName: state.property.coreName,
        assetId: space.uuid,
        assetName: space.assetName,
        layoutId: val.layoutId,
        center: space.center,
        path: space.path,
        allowOverlap: space.allowOverlap || false
      }
    })

    // Ensure placedAssets is an array
    const placedAssets = (val.placedAssets || []).map(asset => {
      const baseAsset = {
        hostId: rootState.session.hostId,
        uuid: asset.uuid,
        coreName: state.property.coreName,
        category: asset.category,
        layoutId: val.layoutId,
        position: asset.position,
        inSpaces: asset.inSpaces
      };

      // If this is a camera, check for locks in the same spaces
      if (asset.category === 'CAMERA' && asset.inSpaces && asset.inSpaces.length > 0) {
        // Find all locks in the same spaces
        const locksInSameSpaces = val.placedAssets.filter(otherAsset =>
          // Check if it's a lock type asset
          (otherAsset.category === 'LOCK' || otherAsset.category === 'KEYPAD_LOCK') &&
          // Check if it shares any space with the camera
          otherAsset.inSpaces.some(spaceId => asset.inSpaces.includes(spaceId))
        );

        // If we found any locks, add them to the camera asset
        if (locksInSameSpaces.length > 0) {
          const locks = {};
          locksInSameSpaces.forEach(lock => {
            locks[lock.uuid] = {
              assetName: lock.assetName
            };
          });
          baseAsset.locks = locks;
        }
      }

      return baseAsset;
    });

    // Ensure availableAssets is an array
    const availableAssets = (val.availableAssets || []).filter(asset => {
      if (placedAssets.find(p => p.uuid === asset.uuid)) {
        return false
      } else {
        return true
      }
    }).map(asset => {
      return {
        hostId: rootState.session.hostId,
        uuid: asset.uuid,
        coreName: state.property.coreName,
        category: asset.category
      }
    })


    rtn = await appsync.refreshLayout({ removedSpaces, newSpaces, updatedSpaces, placedAssets, availableAssets })

    console.log('refreshLayout rtn', rtn)

    if (rtn.errors) {
      throw rtn.errors[0]
    }

  }
}

const mutations = {
  setExpiresAt(state, val) {
    state.expiresAt = val
  },
  setReturnUrl(state, val) {
    state.returnUrl = val
  },
  setHostPms(state, val) {
    state.hostPms = val
  },
  setPmsList(state, val) {
    state.pmsList = val
  },
  setHost(state, val) {
    state.host = val
  },
  setMembers(state, val) {
    state.members = val
  },
  setNotifications(state, val) {
    state.notifications = val
  },
  setReservations(state, val) {
    state.reservations = val
    state.reservationsTimestamp = new Date()
  },
  setListing(state, val) {
    state.listing = val
  },
  setListings(state, val) {
    state.listings = val
  },
  setProperties(state, val) {
    state.properties = val
  },
  setGuideUrl(state, val) {
    state.guideUrl = val
  },
  setReservation(state, val) {
    state.reservation = val
  },
  setReservationRooms(state, val) {
    state.reservationRooms = val
  },
  setFaceImgKeyCount(state, val) {
    state.faceImgKeyCount = val
  },
  setDevices(state, val) {
    state.devices = val
  },
  setLocks(state, val) {
    state.locks = val || []
  },
  setKeypads(state, val) {
    state.keypads = val || []
  },
  setProperty(state, val) {
    state.property = val || []
  },
  setSpaces(state, val) {
    state.spaces = val || []
  },
  setAssets(state, val) {
    state.assets = val || []
  },
  setPlacedAssets(state, val) {
    // Ensure placedAssets is always an array
    state.placedAssets = val || [];
  },
  setRemovedSpaces(state, val) {
    state.removedSpaces = val || [];
  }
}

const getters = {
  allIdVerified: state => {
    console.log('state.members.length', state.members.length)

    let allInputted = false;
    if (state.members.length < state.reservation.memberCount) {
      allInputted = false;
    } else {
      allInputted = state.members.map((memItem) => {

        let isAllInputted = false;
        if (memItem.faceImgKey && memItem.idImgKey && memItem.address && memItem.birthDate && memItem.fullName
          && memItem.gender && memItem.idNumber && memItem.nationality
          && memItem.nextDest && memItem.prevPlace && memItem.occupation) {
          isAllInputted = true;
        }

        return isAllInputted;
      }).every(result => result);
    }

    return allInputted;
  },
  listingSpaces: state => {
    const rtn = state.spaces.map((space) => {
      return {
        assetId: space.assetId,
        assetName: space.assetName,
        allowOverlap: space.allowOverlap
      }
    })

    console.log('listingSpaces', rtn)

    return rtn
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}